import { RolesEnum } from "app/shared/enums/roles.enum";
import { FilterQueryParamNameEnum } from "app/shared/enums/filter-query-param-name.enum.model";
import { FilterTypeEnum } from "../../back-office/shared/enum/filter-type.enum.model";
import { FilterIncompatibilityEnum } from "../enums/filter-incompatibility.enum.model";
import { ShopFilterTypeEnum } from "app/shop/shared/enum/shop-filter-type.enum.model";
import { TemplateRef } from "@angular/core";

export class FilterGroup {
  public name: string;
  public type: FilterTypeEnum | ShopFilterTypeEnum;
  public filterIncompatibility?: FilterIncompatibilityEnum[];
  public queryParamName?: FilterQueryParamNameEnum;
  public withSearch?: boolean;
  public withPagination?: boolean;
  public isRange?: boolean;
  public isAgencyFilterNotByStore?: boolean;
  public isDisable?: boolean;
  public isNotShowOptionAll?: boolean;
  public isDropDownAndChips?: boolean;
  public data?: FilterItem[];
  public dataTotalCount?: number;
  public selected?: FilterItem[];
  public role?: RolesEnum[];
  public userFiltersByRoles?: RolesEnum[];
  public isOnFilterConsiderCurrentStore?: boolean;
  public id?: number;
  public use4shopId?: boolean;
  public showMore?: boolean;
  constructor(init?: FilterGroup) {
    Object.assign(this, init);
    if (!this.data) this.data = [];
    if (!this.selected) this.selected = [];
  }
}

export interface IFilterGroup {
   name: string;
   type: FilterTypeEnum | ShopFilterTypeEnum;
   filterIncompatibility?: FilterIncompatibilityEnum[];
   queryParamName?: FilterQueryParamNameEnum;
   withSearch?: boolean;
   withPagination?: boolean;
   isRange?: boolean;
   isAgencyFilterNotByStore?: boolean;
   isDisable?: boolean;
   isNotShowOptionAll?: boolean;
   isDropDownAndChips?: boolean;
   data?: FilterItem[];
   dataTotalCount?: number;
   selected?: IFilterItem[];
   role?: RolesEnum[];
   userFiltersByRoles?: RolesEnum[];
   isOnFilterConsiderCurrentStore?: boolean;
   id?: number;
   use4shopId?: boolean;
   showMore?: boolean;
}

export class UserFilterGroup extends FilterGroup {
  userFilterRole: RolesEnum;
  selectPlaceholder: string;
  constructor(init?: UserFilterGroup) {
    super();
    Object.assign(this, init);
  }
}



export class FilterItem {
  public text: string;
  public value: any;
  public rgbValue?: string;
  public checked?: boolean;
  constructor(init?: Partial<FilterItem>) {
    Object.assign(this, init);
  }
}

export interface IFilterItem {
  text: string;
  value: any;
  rgbValue?: string;
  checked?: boolean;
}

export class InternalFilterGroup extends FilterGroup {
  public description: string;
  public opened: boolean;
  public isDisablePanel: boolean;
  public declare isDropDownAndChips: boolean;
  public panelId: string;
  public showcaseId: number;

  constructor(init?: Partial<InternalFilterGroup>) {
    super();
    Object.assign(this, init);
  }
}


export class FilterChange {
  filterGroup: InternalFilterGroup;
  filterSelected: FilterItem;
  constructor(init?: Partial<FilterChange>) {
    Object.assign(this, init);
  }
}
export class FilterTask {
  ids: number[];
  type: FilterTypeEnum;
  filterGroupId: number;
  constructor(init?: Partial<FilterTask>) {
    Object.assign(this, init);
  }
}

export class FilterTaskResponse extends FilterTask {
  response: any[];
  constructor(init?: Partial<FilterTaskResponse>) {
    super();
    Object.assign(this, init);
  }
}

export interface OrderFilters {
  seasonReferenceIds: number[];
  salesCampaignIds: number[];
  customerIds: number[];
  posIds: number[];
  dateFrom?: string;
  dateTo?: string;
}